export default {
  soon: 'скоро',
  telegram: 'Канал в Telegram',
  email: 'Рассылка на почту',
  cpText: '&copy;&nbsp;ООО &laquo;ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ МАРКЕТИНГА&raquo;',
  offer: 'Оферта',
  userAgreement: 'Пользовательское соглашение',
  privacyPolicy: 'Политика конфиденциальности',
  expandMenu: 'Развернуть меню',
  collapseMenu: 'Свернуть меню',
  callText: 'Проконсультируем бесплатно по любым вопросам. Звоните.',
  menu: {
    title1: 'Главное',
    link11: 'BIM-модели',
    link12: 'Читальный зал',
    link13: 'Производители',
    link14: 'Личный кабинет',
    link15: 'Термины и определения',
    link16: 'Калькуляторы',
    link17: 'Партнёрские программы',
    link18: 'Открытая статистика',

    title2: 'Каталоги',
    link21: 'Семейства Autodesk Revit (BIM&nbsp;2.0)',
    link22: 'Каталоги Autodesk Civil 3D',
    link23: 'Библиотечные элементы Archicad',
    link24: 'Каталоги Renga',
    link25: 'Каталоги IFC',

    title3: 'Компания',
    link35: 'Тарифы',
    link31: 'О компании',
    link36: 'Партнёрская программа',
    link32: 'Вакансии',
    link34: 'Наши кейсы',

    title4: 'Наши сервисы',
    link41: 'Мастер спецификаций',
    link42: 'Плагин BIMLIB для САПР',
    link43: 'IRMA',
    link44: 'COSTX',
  }
}
